<template>
  <div class="agent-card-container">
    <div class="top-info">
      <span class="network">{{agent.network}}</span>
      <span class="state" style="float: right;">connected</span>
    </div>
    <div class="details">
      <table>
        <tr>
          <td>Domain：</td>
          <td><b>{{agent.domain}}</b></td>
        </tr>
        <tr>
          <td>Server：</td>
          <td><b>{{agent.server}}</b></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ['agent']
}
</script>

<style lang="less" scoped>
.agent-card-container {
  display: inline-block;
  width: 250px;
  border-radius: 5px;
  margin: 15px 5px;
  padding: 10px;
  font-size: 12px;
  color: white;
  background-color: #3f51b5;

  .top-info {
    border-bottom: 1px dashed #ddd;
    padding-bottom: 5px;
  }
  .details {
    border-bottom: 1px dashed #ddd;
    padding-bottom: 5px;
    margin-top: 5px;
  }

  .network {
    font-size: 24px;
    font-family: monospace;
  }

  .state {
    box-shadow: 0 1px 2px rgba(0,0,0,.4);
    background-color: #4caf50;
    color: white;
    padding: 3px .6em;
    border-radius: 5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/RemoteControl/AgentCard.vue